import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Container, Typography } from "@mui/material";
import React from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import CustomLoader from "src/shared_components/CustomLoader";
import { InputField } from "src/shared_components/FormElements";
import * as yup from "yup";
import { useAuth } from "../auth/AuthContext";
import withDynamicTitle from "../hocs/withDynamicTitle";
import { LoginFormData } from "../shared_components/interfaces";

interface AuthenticationProps {}

const Authentication: React.FC<AuthenticationProps> = () => {
  const auth = useAuth();

  const schema = yup.object().shape({
    clientCode: yup.string().required("required"),
    userName: yup.string().required("required"),
    userPassword: yup.string().required("required"),
  });

  const methods = useForm<LoginFormData>({
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, errors },
  } = methods;

  const onSubmit: SubmitHandler<LoginFormData> = async (data) => {
    await auth.signIn(data);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div>
        <Typography component="h1" variant="h5" align="center">
          Login
        </Typography>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <InputField
              fieldName="clientCode"
              label={"Client Code"}
              error={!!errors?.clientCode}
              control={control}
              helperText={errors?.clientCode?.message}
              fullWidth
              other={{ sx: { mt: 2 } }}
            />
            <InputField
              fieldName="userName"
              label={"Username"}
              error={!!errors?.userName}
              control={control}
              helperText={errors?.userName?.message}
              fullWidth
              other={{ sx: { mt: 2 } }}
            />
            <InputField
              fieldName="userPassword"
              label={"Password"}
              error={!!errors?.userPassword}
              control={control}
              helperText={errors?.userPassword?.message}
              fullWidth
              other={{ sx: { mt: 2 }, type: "password" }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ marginY: 2 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? <CustomLoader size={30} /> : "Sign In"}
            </Button>
          </form>
        </FormProvider>
      </div>
    </Container>
  );
};

export default withDynamicTitle(Authentication, "Login");
